import AtoBusiness from "@/business/protocolo/AtoBusiness.js";
import utils from "@/commons/Utils";
import DominioBusiness from "@/business/protocolo/DominioBusiness";
import PapelBusiness from "@/business/PapelBusiness";

const DOMINIOS_TABELIONATO = ['ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL', 'TESTAMENTO', 'SERVICO_TN', 'PROTOCOLO_NOTAS'];
const FGTS_IDS = ['FGTS', 'FGTS_DESCONTO'];

export default {

  nome(dominio){
    switch (dominio) {
      case 'PROTOCOLO_RI':
        return 'Tipos de Ato';
      case 'CERTIDAO_RI':
        return 'Tipos de Certidão';
      case 'OFICIO':
        return 'Tipos de Ofício';
      case 'OCORRENCIA':
        return 'Tipos de Ocorrência';
      case 'NOTIFICACAO':
        return 'Tipos de Notificação';
      case 'PERSONALIZADO':
        return 'Processos Personalizados';
    }
  },

  nomePapel(papel){
    return PapelBusiness.getNomePapel(papel);
  },

  nomePapelCompleto(papel) {
    return PapelBusiness.getNomePapel(papel);
  },

  verificarPapeisEnvolvidos(envolvidos, papeisObrigatorios = []){

    let papeisEnvolvidos = [];
    envolvidos.forEach(envolvido => papeisEnvolvidos.push(envolvido.papel));

    const papeisFaltando = papeisObrigatorios.filter(papel => !papeisEnvolvidos.includes(papel));
    let retorno = '';
    for(let index = 0; index < papeisFaltando.length; index++){
      if(index === 0) retorno = papeisFaltando.length > 1 ? 'Envolvidos com papeis ' : 'Envolvido com papel ';
      if(index+1 < papeisFaltando.length) retorno += this.nomePapel(papeisFaltando[index])+ (index+2 === papeisFaltando.length ? '' : ', ');
      if(index+1 === papeisFaltando.length) retorno += papeisFaltando.length > 1 ? ' e ' +this.nomePapel(papeisFaltando[index]) + ' são obrigatórios' : this.nomePapel(papeisFaltando[index]) + ' é obrigatório';
    }
    return retorno;
  },

  papeis(dominio){
    return PapelBusiness.getCachedPapeisByDominio(dominio);
  },

  tiposDoi(antigos = false) {
    let tipos = [
      {id: 'ADJUDICACAO', nome: 'Adjudicação'},
      {id: 'ARREMATACAO_EM_HASTA_PUBLICA', nome: 'Alienação por iniciativa particular ou leilão judicial'},
      {id: 'CESSAO_DE_DIREITOS', nome: 'Cessão de direitos'},
      {id: 'COMPRA_E_VENDA', nome: 'Compra e venda'},
      {id: 'DACAO_EM_PAGAMENTO', nome: 'Dação em pagamento'},
      {id: 'DISTRATO_DE_NEGOCIO', nome: 'Distrato de Negócio'},
      {id: 'DOACAO_EM_ADIANTAMENTO_DA_LEGITIMA', nome: 'Doação em Adiantamento da Legítima'},
      {id: 'INCORPORACAO_E_LOTEAMENTO', nome: 'Incorporação e Loteamento'},
      {id: 'INTEGRALIZACAO_SUBSCRICAO_DE_CAPITAL', nome: 'Integralização Subscrição de Capital'},
      {id: 'PERMUTA', nome: 'Permuta'},
      {id: 'PROCURACAO_EM_CAUSA_PROPRIA', nome: 'Procuração em Causa Própria'},
      {id: 'PROMESSA_DE_CESSAO_DE_DIREITOS', nome: 'Promessa de Cessão de Direitos'},
      {id: 'PROMESSA_DE_COMPRA_E_VENDA', nome: 'Promessa de Compra e Venda'},
      {id: 'AFORAMENTO', nome: 'Aforamento'},
      {id: 'CASAMENTO', nome: 'Casamento em comunhão universal de bens'},
      {id: 'CISAO', nome: 'Cisão total ou parcial'},
      {id: 'COMPRA_E_VENDA_ENFITEUSE', nome: 'Compra e venda de imóvel gravado por enfiteuse'},
      {id: 'CONCESSAO_CDRU', nome: 'Concessão de Direito Real de Uso (CDRU)'},
      {id: 'CONCESSAO_CUEM', nome: 'Concessão de Uso Especial para Fins de Moradia (CUEM)'},
      {id: 'CONSOLIDACAO', nome: 'Consolidação da Propriedade em Nome do Fiduciário'},
      {id: 'DESAPROPRIACAO_REFORMA_AGRARIA', nome: 'Desapropriação para fins de Reforma Agrária'},
      {id: 'DESAPROPRIACAO_EXCETO_REFORMA_AGRARIA', nome: 'Desapropriação, exceto para Reforma Agrária'},
      {id: 'DIREITO_LAJE', nome: 'Direito de laje'},
      {id: 'DIREITO_SUPERFICIE', nome: 'Direito de Superfície'},
      {id: 'DOACAO_EXCETO_EM_ADIANTAMENTO_DA_LEGITIMA', nome: 'Doação, exceto em Adiantamento de Legítima'},
      {id: 'INCORPORACAO', nome: 'Incorporação'},
      {id: 'INVENTARIO', nome: 'Inventário'},
      {id: 'SEPARACAO_DIVORCIO_UNIAO_ESTAVEL', nome: 'Part. Separação/Divórcio/União Estável'},
      {id: 'RETORNO_DE_CAPITAL_PROPRIO_EXTINCAO_PJ', nome: 'Retorno de Capital Próprio na Extinção de Pessoa Jurídica'},
      {id: 'RETORNO_DE_CAPITAL_PROPRIO_EXCETO_EXTINCAO_PJ', nome: 'Retorno de Capital Próprio, exceto na Extinção de Pessoa Jurídica'},
      {id: 'TITULO_DOMINIO', nome: 'Título de Domínio - TD'},
      {id: 'USUCAPIAO', nome: 'Usucapião'},
      {id: 'OUTROS', nome: 'Outros'},
      {id: 'NENHUM', nome: 'Nenhum'},
    ];

    if(antigos){
      tipos = tipos.concat([
        {id: 'DESAPROPRIACAO', nome: 'Valor Desapropriação'},
        {id: 'DISSOLUCAO_DE_SOCIEDADE', nome: 'Dissolução de Sociedade'},
        {id: 'DOACAO', nome: 'Doação'},
        {id: 'HERANCA_LEGADO_OU_MEACAO', nome: 'Herança, Legado ou Meação (adjudicação)'},
        {id: 'PARTILHA_AMIGAVEL_OU_LITIGIOSA', nome: 'Partilha Amigável ou Litigiosa'},
        {id: 'RETORNO_DE_CAPITAL_PROPRIO', nome: 'Retorno de Capital Próprio'},
        {id: 'DOACAO_96_97', nome: 'Doação (96 e 97) Doação e doação em Adiant. Da Legítima (2.x)'},
        {id: 'RETIFICACAO_ATO', nome: 'Retificação do Ato'}
      ]);
    }

    return tipos;
  },

  tiposCertidao(){
    return [

      {id: 'INTEIRO_TEOR', nome: 'Inteiro Teor'},
      {id: 'INTEIRO_TEOR_SEM_BUSCA', nome: 'Inteiro Teor - Sem Busca (4hrs)'},
      {id: 'ONUS_ACOES', nome: 'Ônus & Ações'},
      {id: 'INFORMACAO_VERBAL', nome: 'Informação Verbal'},
      {id: 'COPIA_POR_PAGINA', nome: 'Cópia Reprográfica por Página'},
      {id: 'RELATORIO', nome: 'Certidão em Relatório'},
      {id: 'QUESITOS', nome: 'Certidão em Relatório com Quesitos'},
      {id: 'UNIDADES_VIRTUAIS', nome: 'Certidão de Atos Virtuais'},
      {id: 'SITUACAO_JURIDICA', nome: 'Certidão de Situação Jurídica'},

      // {id: 'TRANSCRICAO', nome: 'Transcrição'},
      // {id: 'RESUMO', nome: 'Resumo'},
      // {id: 'NEGATIVA_IMOVEL', nome: 'Negativa Imóvel'},
      // {id: 'NEGATIVA_PESSOA', nome: 'Negativa Pessoa'},

    ]
  },

  getLabelRestricaoPapel(restricao) {
    if (!restricao.papeis || !restricao.papeis.length) return '';
    let papeisHabilitados = restricao.papeis.filter(papel => papel.habilitado).map(papel => papel.nome).join(', ');
    return papeisHabilitados ? 'Papéis: ' + papeisHabilitados : 'Papéis: Nenhum papel habilitado';
  },
  formatAuditoriaRestricoes(data) {
  if (!data?.restricoes) return '';
  let html = '';

    for (let i = 0; i < data.restricoes.length ; i++) {
      let restricao = data.restricoes[i];

      // Formato antigo: array de strings (ex: ["ONUS", "ACAO"])
      // Todas as restrições no array estavam habilitadas
      if (typeof restricao === 'string') {
        html += `<b>${this.getLabelRestricao(restricao) || restricao}: Sim</b><br>`;
        continue;
      }

      // Formato novo: array de objetos (ex: {id, nome, habilitada, papeis})
      if (restricao.habilitada) {
        html += `<b>${restricao.nome}: Sim</b><br>`;
        let papel = this.getLabelRestricaoPapel(restricao);
        if (papel) html += `${papel}<br>`;
      } else {
        html += `<b>${restricao.nome}: Não</b><br>`;
      }
    }
  return html;
},

  getLabelRestricao(restricaoId){
    switch (restricaoId) {
      case 'ONUS' : return 'Ônus';
      case 'ACAO' : return 'Ação';
      case 'INDISPONIBILIDADE' : return 'Indisponibilidade';
      case 'COMPROMISSO' : return 'Compromisso de Compra e Venda';
      case 'DOMINIO' : return 'Domínio Útil';
    }
  },

  restricoes(){
    return [
      {id: 'ONUS', nome: 'Ônus'},
      {id: 'ACAO', nome: 'Ação'},
      {id: 'INDISPONIBILIDADE', nome: 'Indisponibilidade'},
      {id: 'COMPROMISSO', nome: 'Compromisso de Compra e Venda'},
      {id: 'DOMINIO', nome: 'Domínio Útil'}
    ]
  },

  restricoesPapeis(){
    return PapelBusiness.restricoesPapeis();
  },

  envolvidosPapeis(){
    return [
      {id: 'INTERESSADO', nome: 'Interessado', habilitado: false},
      {id: 'ANUENTE', nome: 'Anuente', habilitado: false},
      {id: 'CONTRATANTE', nome: 'Contratante', habilitado: false},
      {id: 'INTERVENIENTE', nome: 'Interveniente', habilitado: false},
      {id: 'MEEIRO', nome: 'Meeiro', habilitado: false},
      {id: 'NU_PROPRIETARIO', nome: 'Nu-Proprietário', habilitado: false},
      {id: 'USUFRUTUARIO', nome: 'Usufrutuário', habilitado: false},
      {id: 'LOCADOR', nome: 'Locador', habilitado: false},
      {id: 'LOCATARIO', nome: 'Locatário', habilitado: false},
      {id: 'EXECUTADO', nome: 'Executado', habilitado: false},
      {id: 'EXEQUENTE', nome: 'Exequente', habilitado: false},
      {id: 'REQUERENTE', nome: 'Requerente', habilitado: false},
      {id: 'REQUERIDO', nome: 'Requerido', habilitado: false},
      {id: 'REPRESENTANTE', nome: 'Representante', habilitado: false},
      {id: 'PROCURADOR', nome: 'Procurador', habilitado: false},
      {id: 'PERMUTANTE', nome: 'Permutante', habilitado: false},
      {id: 'SINDICO', nome: 'Síndico', habilitado: false},
      {id: 'NOTIFICADO', nome: 'Notificado', habilitado: false},
      {id: 'NOTIFICANTE', nome: 'Notificante', habilitado: false},
      {id: 'TITULAR', nome: 'Titular', habilitado: false},
      {id: 'INVENTARIANTE', nome: 'Inventariante', habilitado: false},
      {id: 'DESTINATARIO', nome: 'Destinatário', habilitado: false},
      {id: 'TESTEMUNHA', nome: 'Testemunha', habilitado: false},
      {id: 'ADQUIRENTE', nome: 'Adquirente', habilitado: false},
      {id: 'TRANSMITENTE', nome: 'Transmitente', habilitado: false},
      {id: 'CREDOR', nome: 'Credor', habilitado: false},
      {id: 'DEVEDOR', nome: 'Devedor', habilitado: false},
      {id: 'CEDENTE', nome: 'Cedente', habilitado: false},
      {id: 'CESSIONARIO', nome: 'Cessionário', habilitado: false},
      {id: 'AUTOR', nome: 'Autor', habilitado: false},
      {id: 'REU', nome: 'Réu', habilitado: false},
      {id: 'EMITENTE', nome: 'Emitente', habilitado: false},
      {id: 'GARANTIDOR', nome: 'Garantidor', habilitado: false},
      {id: 'FIEL_DEPOSITARIO', nome: 'Fiel Depositário', habilitado: false},
      {id: 'FIADOR', nome: 'Fiador', habilitado: false},
      {id: 'AVALISTA_FIADOR', nome: 'Avalista Fiador', habilitado: false},
      {id: 'COMPROMISSADO', nome: 'Compromissado', habilitado: false},
      {id: 'PROMITENTE_VENDEDOR', nome: 'Promitente Transmitente', habilitado: false},
      {id: 'PROMITENTE_COMPRADOR', nome: 'Promitente Adquirente', habilitado: false},
      {id: 'PROPRIETARIO', nome: 'Proprietário', habilitado: false},
    ]
  },

  operacoesRestricao(){
    return [
      {id: 'CRIAR', nome: 'Criar Restrição'},
      {id: 'CANCELAR', nome: 'Cancelar Restrição'},
      {id: 'REATIVAR', nome: 'Reativar Restrição'},
      {id: 'ALTERAR_CREDOR', nome: 'Alterar Credor'}
    ]
  },

  operacoesCoaf(){
    return [
      {id: 'ADJUDICACAO', nome: 'Adjudicação', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'ARREMATACAO_EM_HASTA_PUBLICA', nome: 'Arrematação em hasta pública', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'CESSAO_DE_DIREITOS', nome: 'Cessão de direitos', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'COMPRA_E_VENDA', nome: 'Compra e venda', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DACAO_EM_PAGAMENTO', nome: 'Dação em pagamento', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DESAPROPRIACAO', nome: 'Valor Desapropriação', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DISSOLUCAO_DE_SOCIEDADE', nome: 'Dissolução de Sociedade', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DISTRATO_DE_NEGOCIO', nome: 'Distrato de Negócio', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DOACAO', nome: 'Doação', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'DOACAO_EM_ADIANTAMENTO_DA_LEGITIMA', nome: 'Doação em Adiantamento da Legítima', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'HERANCA_LEGADO_OU_MEACAO', nome: 'Herança, Legado ou Meação', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'INCORPORACAO_E_LOTEAMENTO', nome: 'Incorporação e Loteamento', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'INTEGRALIZACAO_SUBSCRICAO_DE_CAPITAL', nome: 'Integralização Subscrição de Capital', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'PARTILHA_AMIGAVEL_OU_LITIGIOSA', nome: 'Partilha Amigável ou Litigiosa', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'PERMUTA', nome: 'Permuta', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'PROCURACAO_EM_CAUSA_PROPRIA', nome: 'Procuração em Causa Própria', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'PROMESSA_DE_CESSAO_DE_DIREITOS', nome: 'Promessa de Cessão de Direitos', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'PROMESSA_DE_COMPRA_E_VENDA', nome: 'Promessa de Compra e Venda', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'RETORNO_DE_CAPITAL_PROPRIO', nome: 'Retorno de Capital Próprio', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'OUTROS', nome: 'Outros', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
      {id: 'NENHUM', nome: 'Nenhum', dominio: ['RI', 'RTD', 'RCPJ', 'NOTAS']},
    ]
  },

  tiposRegistro(){
    return [
      {id: 'CEDULA', nome: 'Cédula'},
      {id: 'CONVENCAO_CONDOMINIO', nome: 'Convenção de Condomínio'},
      {id: 'PACTO', nome: 'Pacto Antenupcial'},
      {id: 'OUTROS', nome: 'Outros Títulos'},
    ];
  },

  livros(){
    return [
      {id: 'MATRICULA', nome: 'Matrícula'},
      {id: 'REGISTRO_AUXILIAR', nome: 'Registro Auxiliar'},
      {id: 'TRANSCRICAO', nome: 'Transcrição'},
      {id: 'TORRENS', nome: 'Torrens'},
    ];
  },

  async getRegras() {
    return utils.orderBy([
      {id: 'MATRICULA', nome: 'Matrícula'},
      {id: 'REGISTRO_SIMPLES', nome: 'Registro Simples'},
      {id: 'REGISTRO_SIMPLES_FAR', nome: 'Registro Simples Far'},
      {id: 'REGISTRO_SIMPLES_PMCMV', nome: 'Registro Simples PMCMV'},
      {id: 'REGISTRO_AVANCADO', nome: 'Registro Avançado'},
      {id: 'REGISTRO_INSTITUICAO', nome: 'Registro de Instituição com Especificação de Condomínio'},
      {id: 'REGISTRO_INCORPORACAO', nome: 'Registro de Incorporação'},
      {id: 'REGISTRO_TORRENS', nome: 'Registro Torrens'},
      {id: 'REGISTRO_DEBENTURES', nome: 'Registro Debêntures'},
      {id: 'LOTEAMENTO_GLEBA', nome: 'Loteamento/Gleba'},
      {id: 'CONVENCAO_CONDOMINIO', nome: 'Convenção de Condomínio'},
      {id: 'PACTO_ANTENUPCIAL', nome: 'Pacto Antenupcial'},
      {id: 'REGISTRO_CEDULA', nome: 'Registro Cédula'},
      {id: 'GARANTIA_IMOBILIARIA_RURAL', nome: 'Garantia Imobiliária Rural'},
      {id: 'GARANTIA_IMOBILIARIA_DEMAIS', nome: 'Garantia Imobiliária Demais'},
      {id: 'AVERBACAO', nome: 'Averbação'},
      {id: 'LEI_19571', nome: 'Lei 19.571'},
      {id: 'AVERBACAO_SEM_VALOR', nome: 'Averbação sem Valor'},
      {id: 'RETIFICACAO_HIPOTESE', nome: 'Retificação Hipóteses'},
      {id: 'RETIFICACAO_DEMAIS_HIPOTESES', nome: 'Retificação Demais Hipóteses'},
      {id: 'AVERBACAO_RETIFICACAO_HIPOTESE', nome: 'Averbação Retificação Hipótese'},
      {id: 'NOTIFICACAO_CONFRONTANTE_HIPOTESE', nome: 'Notificação Confrontante Hipótese'},
      {id: 'EXPEDICAO_EDITAL_HIPOTESE', nome: 'Expedição Edital Hipótese'},
      {id: 'RESERVA_LEGAL', nome: 'Reserva Legal'},
      {id: 'CERTIDAO_INTEIRO_TEOR', nome: 'Certidão de Inteiro Teor'},
      {id: 'CERTIDAO_RESUMO_MATRICULA', nome: 'Certidão Reumo de Matrícula'},
      {id: 'CERTIDAO_RELATORIO', nome: 'Certidão em Relatório'},
      {id: 'CERTIDAO_RELATORIO_QUESITOS', nome: 'Certidão em Relatório com Quesitos'},
      {id: 'CERTIDAO_TRANSCRICAO_INSCRICAO', nome: 'Certidão de Transcrição'},
      {id: 'CERTIDAO_NEGATIVA_PESSOA', nome: 'Certidão Negativa de Pessoa'},
      {id: 'CERTIDAO_NEGATIVA_IMOVEL', nome: 'Certidão Negativa de Imóvel'},
      {id: 'CERTIDAO_ONUS_ACOES', nome: 'Certidão de Ônus e Ações'},
      {id: 'CERTIDAO_INFORMACAO_VERBAL', nome: 'Informação Verbal'},
      {id: 'INTIMACAO_PESSOA', nome: 'Intimação por Pessoa'},
      {id: 'EXPEDICAO_EDITAL_INTIMACAO', nome: 'Expedição Edital Intimação'},
      {id: 'INTIMACAO_RURAL_QUILOMETRO', nome: 'Intimação Rural por Quilômetro'},
      {id: 'SEXTA_NOTA_GENERICA', nome: '6ª Nota Genérica'},
      {id: 'SETIMA_NOTA_GENERICA', nome: '7ª Nota Genérica'},
      {id: 'DECIMA_PRIMEIRA_GENERICA', nome: '11ª Genérica'},
      {id: 'COPIA_POR_PAGINA', nome: 'Cópia por Página'},
      {id: 'ATOS_GRATUITOS', nome: 'Atos Gratuitos'},
      {id: 'REGISTRO_PAGAMENTO_POSTERIOR', nome: 'Registro (Pagamento Posterior)'},
      {id: 'AVERBACAO_SEM_VALOR_PAGAMENTO_POSTERIOR', nome: 'Averbação Sem Valor (Pagamento Posterior)'},
      {id: 'USUCAPIAO_INICIO_PROCEDIMENTO', nome: 'Usucapião - Início do procedimento'},
      {id: 'USUCAPIAO_EFETIVACAO_REGISTRO', nome: 'Usucapião - Efetivação do registro'},
      {id: 'AVERBACAO_CEDULA_RURAL', nome: 'Averbação Cédula Rural'},

      {id: 'PAGAMENTO_DIFERIDO_CNIB_AVERBACAO_SEM_VALOR', nome: 'Ordem Judicial CNIB - Pagamento Diferido (Averbação sem valor)'},
      {id: 'PAGAMENTO_DIFERIDO_CNIB_BUSCA', nome: 'Ordem Judicial CNIB - Pagamento Diferido (Busca)'},
      {id: 'PAGAMENTO_DIFERIDO_CNIB_PRENOTACAO', nome: 'Ordem Judicial CNIB - Pagamento Diferido (Prenotação)'},

    ], 'nome')
  },

  camposBaseCalculo(dominio){
    let campos = AtoBusiness.camposBaseCalculo();
    return campos.filter(campo => (campo.dominio || []).includes(dominio));
  },

  camposBaseCalculoSelecionaveis(dominio){
    let campos = this.camposBaseCalculo(dominio);
    if (DOMINIOS_TABELIONATO.includes(dominio)) {
      campos = campos.filter(campo => !FGTS_IDS.includes(campo.id));
    }
    return campos;
  },

  tiposAto(dominio){
    let opcoes = [];

    switch (dominio) {
      case 'SERVICO_TN':
        opcoes.push({id: 'ABERTURA_FIRMA', nome: 'Abertura de Firma'});
        opcoes.push({id: 'RECONHECIMENTO_FIRMA', nome: 'Reconhecimento de Firma'});
        opcoes.push({id: 'AUTENTICACAO_DOCUMENTOS', nome: 'Autenticação de Documentos'});
        opcoes.push({id: 'ABONO_SINAL_PUBLICO', nome: 'Abono de Sinal Público'});
        opcoes.push({id: 'AVERBACAO_TN', nome: 'Averbação'});
        opcoes.push({id: 'OUTRO', nome: 'Outro'});
        break;

      case 'ESCRITURA':
      case 'PROCURACAO':
      case 'SUBSTABELECIMENTO':
      case 'TESTAMENTO':
      case 'ATA_NOTARIAL':
        opcoes.push({id: 'ABERTURA', nome: 'Abertura'});
        opcoes.push({id: 'AVERBACAO', nome: 'Averbação'});
        break;

      default:
        if (!['PROTOCOLO_NOTAS'].includes(dominio)) {
          opcoes.push({id: 'ABERTURA', nome: 'Abertura'});
        }

        opcoes.push({id: 'AVERBACAO', nome: 'Averbação'});
        opcoes.push({id: 'REGISTRO', nome: 'Registro'})
    }

    return opcoes;
  },

  tiposReconhecimento(){
    return [
      {id: 'AUTENTICIDADE', nome: 'Autenticidade'},
      {id: 'SEMELHANCA', nome: 'Semelhança'},
      {id: 'SINAL_PUBLICO', nome: 'Sinal Público'},
      {id: 'SELECIONAR_NO_SERVICO', nome: 'Selecionar no Serviço'}
    ];
  },

  getOperacoesCoaf(dominio) {
    let atribuicao = DominioBusiness.getDominio(dominio);
    return this.operacoesCoaf().filter(t => t.dominio.includes(atribuicao.atribuicao));
  },

  tiposAtoCep() {
    return [
      {id: '1', nome: '1 - Escritura'},
      {id: '2', nome: '2 - Procuração'},
      {id: '3', nome: '3 - Procuração para fins previdenciários'},
      {id: '5', nome: '5 - Renúncia de Procuração'},
      {id: '6', nome: '6 - Revogação de Procuração'},
      {id: '7', nome: '7 - Substabelecimento'},
      {id: '8', nome: '8 - Ata Notarial'},
      {id: '9', nome: '9 - Ata Notarial de Usucapião'},
      {id: '10', nome: '10 - Procuração Privada'},
    ];
  },

  tiposAtoCesdi() {
    return [
      {id: '1', nome: '1 - Separação'},
      {id: '2', nome: '2 - Reconciliação'},
      {id: '3', nome: '3 - Conversão de Separação em Divórcio'},
      {id: '4', nome: '4 - Divórcio Direto'},
      {id: '5', nome: '5 - Inventário'},
      {id: '6', nome: '6 - Sobrepartilha'},
      {id: '7', nome: '7 - Retificação'},
      {id: '8', nome: '8 - Nomeação de Inventariante'},
      {id: '9', nome: '9 - Partilha'},
      {id: '10', nome: '10 - Inventário com menor ou incapaz'},
      {id: '11', nome: '11 - Retificação de ato não notarial'},
    ];
  },

  tiposTestamento() {
    return [
      {id: '1', nome: '1 - Aditamento'},
      {id: '2', nome: '2 - Cerrado'},
      {id: '3', nome: '3 - Revogação'},
      {id: '4', nome: '4 - Testamento'},
      {id: '5', nome: '5 - Testamento com Revogação'},
      {id: '6', nome: '6 - Testamento sem Conteúdo Patrimonial'},
    ];
  },

  tiposAlteracaoStatus(dominio) {
    switch (dominio) {
      case 'ESCRITURA':
      case 'ATA_NOTARIAL':
        return [
          {id: 'ADITAR', nome: 'Aditar'},
          {id: 'RENUNCIAR', nome: 'Renunciar'},
          {id: 'RERRATIFICAR', nome: 'Rerratificar'},
          {id: 'RETIFICAR', nome: 'Retificar'},
          {id: 'DISSOLVER', nome: 'Dissolver'},
          {id: 'REVOGAR', nome: 'Revogar'},
          {id: 'DISTRATAR', nome: 'Distratar'},
          {id: 'TORNAR_SEM_EFEITO', nome: 'Tornar Sem Efeito'},
          {id: 'TORNAR_INCOMPLETO', nome: 'Tornar Incompleto'},
        ];
      case 'PROCURACAO':
      case 'SUBSTABELECIMENTO':
        return [
          {id: 'REVOGAR', nome: 'Revogar'},
          {id: 'RENUNCIAR', nome: 'Renunciar'},
          {id: 'SUBSTABELECER', nome: 'Substabelecer'},
          {id: 'REVOGAR_PARCIALMENTE', nome: 'Revogar Parcialmente'},
          {id: 'SUBSTABELECER_PARCIALMENTE', nome: 'Substabelecer Parcialmente'},
          {id: 'TORNAR_SEM_EFEITO', nome: 'Tornar Sem Efeito'},
          {id: 'TORNAR_INCOMPLETO', nome: 'Tornar Incompleto'},
        ];
      case 'TESTAMENTO':
        return [
          {id: 'ADITAR', nome: 'Aditar'},
          {id: 'RENUNCIAR', nome: 'Renunciar'},
          {id: 'RERRATIFICAR', nome: 'Rerratificar'},
          {id: 'RETIFICAR', nome: 'Retificar'},
          {id: 'DISSOLVER', nome: 'Dissolver'},
          {id: 'REVOGAR', nome: 'Revogar'},
          {id: 'TORNAR_SEM_EFEITO', nome: 'Tornar Sem Efeito'},
          {id: 'TORNAR_INCOMPLETO', nome: 'Tornar Incompleto'},
        ];
      default:
        return [];
    }
  },

  opcoesCensecTipo(dominio) {
    switch (dominio) {
      case 'ESCRITURA':
        return [
          {id: 'CEP', nome: 'CEP'},
          {id: 'CESDI', nome: 'CESDI'},
        ];
      case 'PROCURACAO':
      case 'SUBSTABELECIMENTO':
      case 'ATA_NOTARIAL':
        return [
          {id: 'CEP', nome: 'CEP'},
        ];
      case 'TESTAMENTO':
        return [
          {id: 'RCTO', nome: 'RCTO'},
        ];
      default:
        return [];
    }
  },
}
